import React, {Component} from 'react'
import {findDOMNode} from 'react-dom'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Modal from 'react-modal'
import {ADD_MEDIA, hideModal} from '../../../../modules/modals'
import {questionSelector, uploadImage} from '../../../../modules/questions'
import { reduxForm, Field } from 'redux-form'
import {required, youtube} from '../../../common/Form/rules'
import Dropzone from 'react-dropzone'
import {MAX_SIZE_BYTES, ACCEPTED_IMG_FORMATS} from './utils'
import {lifecycle} from 'recompose'


class AddMediaModal extends Component {
    state = {
        imgErrors : {
            maxSize : "",
            format : "",
        },
    }
    render() {
        let {zIndex} = this.props
        return (
            <Modal
                isOpen = {true}
                style = {{
                    overlay : {zIndex},
                }}
                onRequestClose={this.handleClose}
                overlayClassName = "custom-modal"
                className = "custom-modal-content create-dialog-modal-content"
            >
                <div className="create-dialog-modal-content__header">
                    {
                        this.getTitle()
                    }
                    <div
                        onClick={this.handleClose}
                        className="create-dialog-modal-content__close"
                    ></div>
                </div>
                <div className="create-dialog-modal-content__body">
                    {
                        this.getBody()
                    }
                </div>
            </Modal>
        )
    }

    getTitle = () => {
        const {mediaType} = this.props
        const {formatMessage} = this.context
        let text
        switch (mediaType) {
            case "video" : {
                text = "Insert YouTube video"
                break
            }
            case "image" : {
                text = "Upload image" //"Insert image link or upload image"
                break
            }
            default : {
                text = ""
                break
            }
        }
        return (
            <div className="create-dialog-modal-content__title">{formatMessage(text)}</div>
        )
    }

    getBody = () => {
        const {mediaType} = this.props
        const {formatMessage} = this.context
        switch (mediaType) {
            case "video" : {
                return (
                    <this.AddVideoForm
                        mediaType = {mediaType}
                        label = {formatMessage("Link for YouTube video")}
                        okButtonTxt = {formatMessage("Insert")}
                        cancelButtonTxt = {formatMessage("Cancel")}
                    />
                )
                break
            }
            case "image" : {
                return (
                    <this.AddImageForm
                        mediaType = {mediaType}
                        label = {formatMessage("Link for image")}
                        okButtonTxt = {formatMessage("Insert")}
                        okButtonTxt2 = {formatMessage("Upload")}
                        cancelButtonTxt = {formatMessage("Cancel")}
                        imgErrors = {this.state.imgErrors}
                    />
                )
                break
            }
            default : {
                return null
                break
            }
        }
    }

    Form = lifecycle({
        componentDidMount : () => {
            this.setFocus()
        }
    })((props) => {
        const {question : {uploadingImg}} = this.props
        const {handleSubmit, submitting, error, label, okButtonTxt, okButtonTxt2, mediaType, cancelButtonTxt, imgErrors = []} = props
        const {formatMessage} = this.context

        let validate = [required]
        if (mediaType === 'video') validate = [...validate, youtube]

        return (
            <form onSubmit={handleSubmit} className="create-dialog-form">
                {
                    mediaType !== 'image' && // TODO temporary remove functionality of adding link to image
                    <Field
                        name = "src"
                        id = "src"
                        type = "text"
                        component = {this.RenderInput}
                        validate = {validate}
                        label = {label}
                        ref = {this.getFieldRef}
                    />
                }
                {
                    error &&
                    <div className="row">
                        <div className="col-xs-12 text-center text-danger">{error}</div>
                    </div>
                }
                {
                    Object.values(imgErrors).map(err => (
                        err &&
                        <div key = {err} className="row mb-3">
                            <div className="col-xs-12 text-center text-danger">{formatMessage(err)}</div>
                        </div>
                    ))
                }
                <div className="create-dialog-form__group flex flex-between">
                    {
                        mediaType !== 'image' && // TODO temporary remove functionality of adding link to image
                        <button
                            disabled={submitting}
                            className="btn btn-primary"
                            type="submit"
                        >{okButtonTxt}</button>
                    }
                    {
                        mediaType === 'image' &&
                        <Dropzone
                            accept={ACCEPTED_IMG_FORMATS.join(", ")}
                            onDropAccepted={this.onDropAccepted}
                            onDropRejected={this.onDropRejected}
                            style={{}}
                            multiple={false}
                            maxSize = {MAX_SIZE_BYTES}
                            disableClick={true}
                            ref = {this.getDropzoneRef}
                        >
                            <button
                                onClick={this.handleUploadClick}
                                disabled={submitting || uploadingImg}
                                className="btn btn-primary mr-auto"
                                type="button"
                            >{okButtonTxt2}</button>
                        </Dropzone>
                    }
                    <button
                        onClick={this.handleClose}
                        className="btn btn-warning"
                        type="button"
                    >{cancelButtonTxt}</button>
                </div>
            </form>
        )
    })
    AddVideoForm = reduxForm({
        form: 'addVideo',
        onSubmit : (values) => {
            const {addMedia} = this.props
            const {src} = values
            addMedia(src)
            this.handleClose()
        }
    })(this.Form)
    AddImageForm = reduxForm({
        form: 'addImage',
        onSubmit : (values) => {
            const {addMedia} = this.props
            const {src} = values
            addMedia(src)
            this.handleClose()
        }
    })(this.Form)
    onDropAccepted = (files) => { // TODO
        const {questionId, uploadImage, addMedia, editorType} = this.props
        let file = files[0]
        this.setState(()=>({imgErrors : { maxSize : "", format : ""}}))
        uploadImage({
            questionId,
            img : file,
            successCB : (imgSrc) => addMedia(imgSrc),
            finalCB : () => this.handleClose(),
            editorType,
        })
    }
    onDropRejected = (files) => {
        let file = files[0]
        if (!ACCEPTED_IMG_FORMATS.includes(file.type)) {
            const formats = ACCEPTED_IMG_FORMATS.reduce(function (acc, curr, index, arr) {
                return acc += `.${curr.slice(6)}${index !== arr.length - 1 ? ", " : ""}`
            }, "")
            this.setState((prevState) => {
                return {
                    ...prevState,
                    imgErrors : {
                        ...prevState.imgErrors,
                        format : `Only images of ${formats} formats are allowed.`
                    }
                }
            })
        } else if (file.size > MAX_SIZE_BYTES) {
            this.setState((prevState) => {
                return {
                    ...prevState,
                    imgErrors : {
                        ...prevState.imgErrors,
                        maxSize : `Max size for image is ${MAX_SIZE_BYTES / 1000000} megabytes.`
                    }
                }
            })
        }
    }
    getDropzoneRef = (ref) => this.dropZoneRef = ref
    handleUploadClick = () => !this.props.question.uploadingImg && this.dropZoneRef && this.dropZoneRef.open()
    RenderInput = ({input, meta : {touched, error}, ...customProps}) => {
        const {label, type, id} = customProps
        return (
            <div className="create-dialog-form__group create-dialog-form__group--indent-bottom">
                <label htmlFor={id}>{label}</label>
                <input
                    {...input}
                    id={id}
                    className="create-dialog-form__control"
                    type={type}
                />
                {
                    touched && error && <span style={{color:"red"}}>{this.context.formatMessage(error)}</span>
                }
            </div>
        )
    }
    handleClose = () => this.props.hideModal({ modalType : ADD_MEDIA})

    getFieldRef = ref => {
        if (ref) this.input = findDOMNode(ref).querySelector('input')
    }
    setFocus = () => this.input && this.input.focus()

    static contextTypes = { formatMessage: PropTypes.any }
}

export default connect(
    (state, {questionId}) => ({
        question : questionSelector(state, questionId),
    }),
    {hideModal, uploadImage},
    null,
    {pure : false}
)(AddMediaModal)


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QbmPage/QbmBody/TextEditor/AddMediaModal.js